import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Link,
  Popover,
  Typography,
} from '@mui/material';
import { MouseEvent, useState } from 'react';
import { AutoComplete } from '../AutoComplete/AutoComplete';
import { Vendor } from '../../store/config/types/warehouseWork.types';
import WarehouseWorkService from '../../services/warehouseWork.service';

export interface VendorEditLinkProps {
  vendorId?: number;
  vendorName?: string;
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onSubmit?: (vendorId: number, vendorName: string) => void;
}

// eslint-disable-next-line no-unused-vars
export default function VendorEditLink({ vendorId, vendorName, disabled, onSubmit }: VendorEditLinkProps) {
  const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  function handleOpenPopover(event: MouseEvent<HTMLElement>) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setSelectedVendor(null);
    setAnchorEl(null);
  }

  function handleChange() {
    if (onSubmit && selectedVendor) {
      onSubmit(selectedVendor.vendorId, selectedVendor.displayName);
    }
    handleClose();
  }

  const openPopover = Boolean(anchorEl);

  return (
    <>
      <Link onClick={disabled ? undefined : handleOpenPopover} sx={{ cursor: 'pointer' }}>
        <Typography variant="subtitle1" color={!vendorName ? 'gray' : disabled ? 'black' : undefined}>
          {vendorName || 'Select a vendor'}
        </Typography>
      </Link>

      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        onClick={(e) => e.stopPropagation()}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <DialogTitle>
          <Typography variant="subtitle2">Change Vendor</Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container pt={2} flexDirection="column" gap={1} style={{ minWidth: 300 }}>
            <AutoComplete<Vendor>
              fetchFn={WarehouseWorkService.searchVendor}
              renderItem={(vendor) => `${vendor.displayName} (${vendor.externalId ?? ''})`}
              getItemValue={(vendor) => vendor.displayName}
              onSelect={(vendor) => setSelectedVendor(vendor)}
              label="Search Vendor"
              placeholder="Type to search..."
              minLength={2}
            />
            {selectedVendor && (
              <Typography variant="body2" color="textSecondary">
                Selected: {selectedVendor.displayName}
              </Typography>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container>
            <Grid item flexGrow={1} />
            <Grid item>
              <Button variant="text" color="error" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="contained" color="success" disabled={!selectedVendor} onClick={handleChange}>
                Change
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Popover>
    </>
  );
}
